function ExpandableContent() {
  return null;
}

ExpandableContent.displayName = 'ExpandableContent';

export default ExpandableContent;



// WEBPACK FOOTER //
// ./containers/Expandable/ExpandableContent.js